import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../diccionarios/moduloVMI';

@Injectable({
  providedIn: 'root'
})
export class VmiUsuariosService {

  diccionarioUrl: any = {};
  url: string;

  constructor(
    private _commom: CommonService,
    private _utils: UtilsService
  ) {
    this.url = this._utils.getVmi();
    this.diccionarioUrl = moduloVMI.url.administracion;
  }

  getAll(): Observable<any[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.usuarios);
  }

  create(innObj: any): Observable<any> {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioUrl.usuarios, innObj);
  }

  edit(innObj: any): Observable<any> {
    return this._commom.peticionPutConHeader(this.url + this.diccionarioUrl.usuarios, innObj);
  }

  delete(innIdObj: number): Observable<any> {
    return this._commom.peticionDeleteConHeader(this.url + this.diccionarioUrl.usuarios + `/${innIdObj}`);
  }
}
